import { TextField } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import { DialogProps } from "@saleor/types";
import React from "react";

import { formatDateWithTime } from "../../utils/handlers";

export interface GenerateDialogForm {
  startDate: string;
  endDate: string;
  creditDate: string;
}

interface GenerateBatchDialogProps extends DialogProps {
  onGenerateBatch: (formData: GenerateDialogForm) => void;
  buttonState?: ConfirmButtonTransitionState;
}

const useStyles = makeStyles(
  () => ({
    form: {
      "& .MuiFormControl-root": {
        marginBottom: "1em"
      }
    },
    singleSelectField: {
      "& label": {
        overflowX: "visible",
        width: "100%"
      }
    }
  }),
  {
    name: "GenerateBatchDialog"
  }
);

const GenerateBatchDialog: React.FC<GenerateBatchDialogProps> = props => {
  const { open, onClose, onGenerateBatch, buttonState } = props;
  const classes = useStyles(props);

  const handleSubmit = formData => {
    onGenerateBatch({
      creditDate: formatDateWithTime(formData.creditDate),
      endDate: formatDateWithTime(formData.endDate),
      startDate: formatDateWithTime(formData.startDate)
    });
  };

  return (
    <>
      <Dialog
        maxWidth="xs"
        fullWidth
        open={open}
        onClose={buttonState !== "loading" && onClose}
        className={classes.form}
      >
        <DialogTitle>Generate Batch</DialogTitle>
        <Form
          initial={{
            creditDate: null,
            endDate: null,
            startDate: null
          }}
          onSubmit={handleSubmit}
        >
          {({ data, change, submit }) => (
            <>
              <DialogContent>
                <label>Start Date</label>
                <TextField
                  className={classes.singleSelectField}
                  disabled={false}
                  type="date"
                  name="startDate"
                  onChange={change}
                  value={data.startDate}
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <FormSpacer />
                <label>End Date</label>
                <TextField
                  className={classes.singleSelectField}
                  disabled={false}
                  type="date"
                  name="endDate"
                  onChange={change}
                  value={data.endDate}
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <FormSpacer />
                <label>Settlement Date</label>
                <TextField
                  className={classes.singleSelectField}
                  disabled={false}
                  type="date"
                  name="creditDate"
                  onChange={change}
                  value={data.creditDate}
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  fullWidth
                  disabled={buttonState === "loading"}
                  style={{ flexBasis: "50%" }}
                  variant="contained"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                {/* <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={submit}
                  disabled={
                    data.creditDate === null ||
                    data.startDate === null ||
                    data.endDate == null
                  }
                >
                  Generate
                </Button> */}

                <ConfirmButton
                  fullWidth
                  transitionState={buttonState}
                  color="primary"
                  disabled={
                    data.creditDate === null ||
                    data.startDate === null ||
                    data.endDate == null ||
                    buttonState === "loading"
                  }
                  keepLabel={true}
                  style={{ flexBasis: "50%" }}
                  variant="contained"
                  onClick={submit}
                >
                  Generate
                </ConfirmButton>
              </DialogActions>
            </>
          )}
        </Form>
      </Dialog>
    </>
  );
};

export default GenerateBatchDialog;
